export function App() {
  return (
    <main style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem' }}>
      <h1>Interface administration / formateurs</h1>
    </main>
  );
}
